export const note = () => ({
    maxWidth: 556,
});

export const value = ({ theme: { colors } }) => ({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.56,
    letterSpacing: '0.2px',
    color: colors.text,
    whiteSpace: 'pre-wrap',
});
